import HeaderComponent from "../component/HeaderComponent";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useLocation } from "react-router-dom";
import HomeSlider from "../component/HomeSlider";
import CurrentNew from "../component/CurrentNew";
import Footer from "../component/Footer";
import Menu from "../component/Menu";
import HomeCarousel from "../component/HomeCarousel";
import CasinoOverlay from "./casino/CasinoOverlay";
import Logout from "../component/Logout";
import Announcement from "../component/Announcement";
import PopUp from "./casino/PopUp";
import { isEmpty } from "lodash";
import { isMobile } from "react-device-detect";
import MenuWeb from "../component/MenuWeb";
import Login from "../component/Login";
import ProfileModal from "../component/ProfileModal";
import ThemeContext from "../context/ThemeContext";
import BottomNavigation from "../component/BottomNavigation";
import { useCallback, useEffect, useRef, useState } from "react";
import DownloadBar from "../component/DownloadBar";
import MenuNew from "../component/MenuNew";
import LanguageSelect from "../component/LanguageSelect";
import MenuAccount from "../component/MenuAccount";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";

const Layout = ({ children }) => {
  
  const menuModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.menuModal;
  });
  const showCasino = useContextSelector(AuthContext, (ctx) => {
    return ctx.showCasino;
  });
  const betLoader = useContextSelector(AuthContext, (ctx) => {
    return ctx.betLoader;
  });
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  const logoutShow = useContextSelector(AuthContext, (ctx) => {
    return ctx.logoutShow;
  });
  const casinoBefore = useContextSelector(AuthContext, (ctx) => {
    return ctx.casinoBefore;
  });
  const sidebarModalAccount = useContextSelector(AuthContext, (ctx) => {
    return ctx.sidebarModalAccount;
  });

  const announcement = useContextSelector(AuthContext, (ctx) => {
    return ctx.announcement;
  });
  const loginModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.loginModal;
  });
  const profileModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileModal;
  });
  const showCasinoUrl = useContextSelector(AuthContext, (ctx) => {
    return ctx.showCasinoUrl;
  });
  const sidebarModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.sidebarModal;
  });
  const [downloadBar, setDonwloadBar] = useState(true);
  useEffect(() => {
    if (localStorage.getItem("downloadBar") == "false") {
      setDonwloadBar(false);
    } else {
      setDonwloadBar(true);
    }
  }, []);
  const [language, setLanguage] = useState(false);

  const location = useLocation();

  let loc = location?.pathname?.split("/")[1];
  const background = location.state?.background;
  let condiSports =
    ["match-detail", "sports"].includes(location?.pathname?.split("/")[1]) ||
    ["match-detail", "sports"].includes(background?.pathname?.split("/")[1]);

  const [isCondition, setIsCondition] = useState(true);
  useEffect(() => {
    const check = () => setIsCondition(!document.querySelector(".pop-bg"));
    check();
    const observer = new MutationObserver(check);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);
  return (
        <app-root>
      <div
        style={{ position: "relative" }}
        className="main-router-wrapper ng-tns-c3783694019-0 ng-trigger ng-trigger-routeFullPageAni"
      >
        {betLoader && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              height: "100vh",
              width: "100vw",
              backgroundColor: "transparent",
              zIndex: 9999,
              cursor: "not-allowed",
            }}
          />
        )}
        <div
          className={
            !isMobile
              ? `layout-desktop ng-tns-c1218069548-2 ${
                  sidebarModal ? "layout-desktop--menu-open" : ""
                }`
              : ""
          }
        >
          <div
            className={
              !isMobile ? "layout-desktop__inner ng-tns-c1218069548-2" : ""
            }
          >
            {isMobile && <MenuNew />}
            {isMobile && sidebarModalAccount && <MenuAccount />}
            <div
              className={
                !isMobile
                  ? "layout-desktop__main ng-tns-c1218069548-2 ng-trigger ng-trigger-routeLayoutPageAni"
                  : ""
              }
            >
              {!menuModal && (
                <HeaderComponent />
              )}
              <div
                className={
                  isMobile
                    ? "wrap  ng-star-inserted"
                    : `layout-desktop__body ng-tns-c1218069548-2 ${
                        condiSports ? "cricket-bg" : ""
                      }`
                }
                style={
                  condiSports
                    ? {
                        backgroundImage: `url(/assets/images/bg-cricket.jpg)`,
                      }
                    : {}
                }
              >
                <div
                  className={
                    isMobile
                      ? "wrap-inner "
                      : "layout-desktop__body-inner ng-tns-c1218069548-2"
                  }
                >
                  <div
                    className={
                      isMobile
                        ? "content cricket"
                        : "layout-desktop__content ng-tns-c1218069548-2"
                    }
                  >
                    {(background?.pathname == "/" ||
                      location?.pathname == "/") && <HomeCarousel />}
                    {condiSports ? (
                      children
                    ) : (
                      <div
                        id="mainWrapper"
                        className="main-wrapper ng-star-inserted"
                      >
                        {(background?.pathname == "/" ||
                          location?.pathname == "/") && (
                          <>
                            <CurrentNew />
                          </>
                        )}

                        {children}
                      </div>
                    )}
                  </div>{" "}
                  <Footer />
                </div>
              </div>
            </div>
            {!isMobile && <MenuWeb />}
            {announcement && isMobile && <Announcement />}
            {logoutShow && <Logout />}
            {showCasino && !isEmpty(showCasinoUrl) && (
              <CasinoOverlay showCasinoUrl={showCasinoUrl} />
            )}
            {!condiSports &&
              !["casino"].includes(loc) &&
              isMobile &&
              isCondition && <BottomNavigation setLanguage={setLanguage} />}
            {casinoBefore && <PopUp />} {loginModal && <Login />}
            {profileModal && <ProfileModal />}
            {downloadBar && isMobile && location?.pathname == "/" && (
              <DownloadBar onClose={setDonwloadBar} />
            )}
            {language && <LanguageSelect setLanguage={setLanguage} />}
          </div>{" "}
        </div>
      </div>{" "}
     
    </app-root>
  );
};

export default Layout;
